<template>
  <div data-cy="page-recapitulatif-sante">
    <SlHeader
      :current-step="4"
      :links="headerLinks"
    />

    <sl-separator class="mb-4" />

    <recapitulatif-intro :user="user" />

    <recapitulatif-personal-informations :user="user" />

    <recapitulatif-needs-sante :user="user" />

    <recapitulatif-complementary-informations :user="user" />

    <recapitulatif-final />

    <sl-button
      v-if="user.partenaireCanSign && !user.fromUrlAppo"
      @click="submit()"
    >
      Confirmer ma souscription en ligne
    </sl-button>

    <a
      v-if="!(user.partenaireCanSign && !user.fromUrlAppo)"
      :href="downloadDocumentsURL"
      target="_blank"
    ><sl-button>Télécharger les documents récapitulatifs</sl-button></a>
  </div>
</template>

<script>

import {useVuelidate} from '@vuelidate/core'
import SlButton from "src/modules/shared/components/SlButton";
import SlSeparator from "src/modules/shared/components/SlSeparator";
import {computed, onMounted, ref} from "vue";
import RecapitulatifSanteService from "src/modules/recapitulatif/services/recapitulatif-sante.service";
import RecapitulatifFinal from "src/modules/recapitulatif/components/RecapitulatifFinal";
import RecapitulatifPersonalInformations from "src/modules/recapitulatif/components/RecapitulatifPersonalInformations";
import RecapitulatifNeedsSante from "src/modules/recapitulatif/components/RecapitulatifNeedsSante";
import RecapitulatifComplementaryInformations from "src/modules/recapitulatif/components/RecapitulatifComplementaryInformations";
import RecapitulatifIntro from "src/modules/recapitulatif/components/RecapitulatifIntro";
import SlHeader from "src/modules/shared/components/SlHeader";

export default {
  name: "RecapitulatifSante",
  components: {
    RecapitulatifComplementaryInformations,
    RecapitulatifFinal,
    RecapitulatifIntro,
    RecapitulatifNeedsSante,
    RecapitulatifPersonalInformations,
    SlButton,
    SlHeader,
    SlSeparator
  },
  setup() {
    const initialState = window.__INITIAL_STATE__ || {}
    let user = ref({})

    const headerLinks = computed(() => [
      user.value ? user.value.devoirDeConseilUrl : null,
      user.value ? user.value.quoteUrl : null,
      user.value ? user.value.souscriptionUrl : null,
    ])

    onMounted(async () => {
      await RecapitulatifSanteService.getUserInformations().then(res => {
        console.debug('RecapitulatifSante', 'getUser', res.data)
        user.value = res.data
      })
    })

    return {
      v$: useVuelidate(),
      user,
      initialState,
      headerLinks
    }
  },
  computed: {
    downloadDocumentsURL: () => {
      return RecapitulatifSanteService.getDownloadDocumentsURL()
    }
  },
  methods: {
    async submit() {
      await RecapitulatifSanteService.submitForm().then(res => {
        console.log(res.data)
      })
    }
  }
}
</script>

<style scoped>

</style>
